module.exports = __webpack_public_path__ + "img/StealthOverhead.dd6d32d5.png";